import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import faqs from '../../data/faqs';
import Container from '../Basic/Container';
import Desc from '../Basic/Desc';
import Heading from '../Basic/Heading';

const Wrap = styled.div`
	padding: ${props => props.theme.vr * 5}rem 0;

	${rmq('ml')} {
		padding: ${props => props.theme.vr * 3}rem 0;
	}
`;
const FAQ = styled.div`
	display: table;
	width: 100%;
	margin: 0 0 ${props => props.theme.vr * 1}rem;
	transition: all 0.4s ease;
	padding: ${props => props.theme.vr * 1}rem;

	&:hover {
		background: #fff;
		border-radius: 1rem;
		box-shadow: 0 1rem 5rem 0 rgba(14, 30, 37, 0.12);
	}

	${rmq('ml')} {
		margin: 0 0 ${props => props.theme.vr * 1}rem;
	}
`;
const Img = styled.div`
	display: table-cell;
	width: 20%;
	vertical-align: top;
	padding: ${props => props.theme.vr * 1}rem;

	${rmq('550')} {
		display: table;
		width: 20%;
	}
	${rmq('ml')} {
		width: 35%;
		margin: 0 auto;
	}
`;
const QA = styled.div`
	display: table-cell;
	width: 80%;
	vertical-align: middle;
	padding: 0 ${props => props.theme.vr * 1}rem;

	${rmq('550')} {
		display: table;
		width: 100%;
	}
`;
const Query = styled.h3`
	font-family: ${props => props.theme.f1};
	font-size: ${props => props.theme.vr * 1.5}rem;
	font-weight: 400;
	margin: 0 0 ${props => (props.theme.vr * 1) / 2}rem;
	color: ${props => props.theme.black1};

	${rmq('ml')} {
		font-size: ${props => props.theme.vr * 1}rem;
		font-weight: 900;
		text-align: center;
	}
`;
const Answer = styled.p`
	margin-top: 0;
	color: ${props => props.theme.gray3};

	${rmq('ml')} {
		font-size: 1.6rem;
	}

	a {
		color: ${props => props.theme.c2};
		transition: all 0.4s ease-in;
		text-decoration: none;
		border-bottom: 3px solid ${props => props.theme.cg2};
		box-shadow: inset 0 -1rem 0 ${props => props.theme.cg2};
		transition: 0.4s all ease-out;

		&:hover {
			box-shadow: inset 0 -5.5rem 0 ${props => props.theme.ct};
			border-bottom: 3px solid ${props => props.theme.ct};
		}
	}
`;

export default () => (
	<Container>
		<span id="FAQ" />
		<Heading>Frequently Asked Questions?!</Heading>
		<Desc>You got questions? I got answers!</Desc>
		<Wrap>
			{faqs.map((faq, i) => (
				<FAQ key={i}>
					<Img>
						<img className="lazyload" data-src={faq.img} alt={faq.query} loading="lazy" />
					</Img>
					<QA>
						<Query>{faq.query}</Query>
						<Answer dangerouslySetInnerHTML={{ __html: faq.answer }} />
					</QA>
				</FAQ>
			))}
		</Wrap>
	</Container>
);
